import React from "react";
import { ProductType } from "module/types";
import { useTranslation } from "react-i18next";
import "sass/components/FilterButtons.scss";

type FilterButtonsProps = {
  selectedTypes: ProductType[];
  onToggle: (type: ProductType) => void;
};

const FilterButtons = ({ selectedTypes, onToggle }: FilterButtonsProps) => {
  const { t } = useTranslation();

  const filterTypes = [
    { type: ProductType.RECREATION, label: t("game"), icon: "fa-solid fa-gamepad" },
    { type: ProductType.TOOL, label: t("usefulTools"), icon: "fa-solid fa-tools" },
  ];

  return (
    <div className="filter-buttons">
      {filterTypes.map((filter) => (
        <button
          key={filter.type}
          className={`filter-button ${
            selectedTypes.includes(filter.type) ? "active" : ""
          }`}
          onClick={() => onToggle(filter.type)}
        >
          <i className={filter.icon} />
          <span>{filter.label}</span>
        </button>
      ))}
    </div>
  );
};

export default FilterButtons;